import { connect } from 'react-redux';
import { setJoiningStatus } from '../../../actions/conversation';
import ConversationView from './ConversationView';
const mapStateToProps = ({ scribeConversation: { conversationOrigin, conversationRequested, conversationStarted, isInConversation, joiningStatus, scribe, status, }, scribeSession: { captioner, currentPlatform, displayable, lightView, loading, loggingOut, muted, socketConnectionStatus, }, scribeTranscriptUI: { fullScreen, insertSpeakerNameMode, updateAudioSourceMode }, }) => ({
    conversationOrigin,
    conversationRequested,
    conversationStarted,
    currentPlatform,
    displayable,
    fullScreen,
    insertSpeakerNameMode,
    isInConversation,
    joiningStatus,
    lightView,
    loading,
    loggingOut,
    muted,
    scribe,
    socketConnectionStatus,
    status,
    updateAudioSourceMode,
    user: captioner,
});
const mapDispatchToProps = {
    setJoiningStatus,
};
export default connect(mapStateToProps, mapDispatchToProps)(ConversationView);
